import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
  jobFunctionsLength: 0,
  jobFunctions: [],
  jobFunction: {},
  jobFunctionError: "",
  formError: "",
};

export default function JobFunctionReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADING_JOB_FUNCTION:
      return { ...state, loading: action.payload };
    case actions.LOADING_JOB_FUNCTION_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_JOB_FUNCTION:
      return { ...state, saveLoading: action.payload };
    case actions.GET_JOB_FUNCTION:
      return {
        ...state,
        jobFunctions: action.payload.jobFunctions,
        jobFunctionsLength: action.payload.jobFunctionsLength,
      };
    case actions.GET_JOB_FUNCTION_BY_ID:
      return {
        ...state,
        jobFunction: action.payload,
      };
    case actions.FORM_FAIL_JOB_FUNCTION:
      return { ...state, formError: action.payload };
    case actions.JOB_FUNCTION_FAIL:
      return { ...state, jobFunctionError: action.payload };
    default:
      return state;
  }
}
